<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <div>
            <span>{{ shopInfo.edcShopType != 2 ? "团长" : "分销商" }}总数：</span>
            {{ pageCount }}
          </div>
        </div>
        <div class="header-right">
          <div>
            <span>手机号：</span>
            <el-input
              v-model="phoneNum"
              size="small"
              placeholder="请输入手机号"
            ></el-input>
          </div>
          <el-button type="primary" size="small" @click="searchDistribution"
            >查询</el-button
          >
        </div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="distributionList" style="width: 100%">
            <el-table-column label="id">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.customerUserId }}</div>
              </template>
            </el-table-column>
            <el-table-column label="姓名">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.fullName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="手机号">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.phoneNum }}</div>
              </template>
            </el-table-column>
            <el-table-column label="加入时间">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.becomeMemberTime }}</div>
              </template>
            </el-table-column>
            <el-table-column label="可提现金额">
              <template slot-scope="scope">
                <div class="name">
                  {{
                    scope.row.availableAmount ? `￥${scope.row.availableAmount}` : `￥0`
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  @click="linkToRelationship(scope.row.customerUserId)"
                  >查看</el-button
                >
                <el-button type="danger" size="small" @click="delDealer(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDealerListPage, getDealerChildCount, delDealer } from "@/api/index.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      statusList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "未分佣",
          value: 0,
        },
        {
          label: "已分佣",
          value: 1,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      distributionList: [],
      pageSize: 10,
      pageCount: 0,
      pageNo: 1,
      phoneNum: "",
      distributionCount: 0,
    };
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
  },
  watch: {
    time(val) {
      console.log(val);
      if (val) {
        this.startTime = new Date(val[0]).pattern("yyyy-MM-dd");
        this.endTime = new Date(val[1]).pattern("yyyy-MM-dd");
      } else {
        this.startTime = "";
        this.endTime = "";
      }
    },
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.pageNo = 1;
      this.getDealerListPage();
      // this.getDealerChildCount();
    },
    getDealerListPage() {
      getDealerListPage({
        pageNumber: this.pageNo,
        pageSize: this.pageSize,
        phoneNum: this.phoneNum,
      }).then((res) => {
        if (res.code == 1) {
          this.distributionList = res.data.list;
          this.pageCount = res.data.totalCount;
        }
        if (res.code == -1) {
          this.distributionList = [];
          this.pageCount = 0;
        }
      });
    },
    getDealerChildCount() {
      getDealerChildCount().then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.distributionCount = res.data.totalCount;
        }
      });
    },
    searchDistribution() {
      this.getPageData();
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getDealerListPage();
    },
    linkToRelationship(userId) {
      this.$router.push({
        path: "/distribution/relationship",
        query: {
          userId: userId,
        },
      });
    },
    showChiefQrcode(id) {},
    delDealer(item) {
      console.log(item);
      this.$confirm("此操作将永久删除, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        delDealer({
          shopMemberId: item.shopMemberId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "删除成功",
              type: "success",
              duration: 1000,
            });
            this.getDealerListPage();
          } else {
            this.$notify.error("错误", res.msg);
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .header-left {
    height: 30px;
    align-items: center;
  }
  .header-right {
    & > div {
      .el-input {
        display: inline-block;
        width: 130px;
      }
    }
    & > div + div {
      margin-left: 10px;
    }
    .el-button {
      margin-left: 10px;
    }
  }
  .upload-xls {
    margin: 0 10px;
  }
  .list {
    width: 100%;
    padding: 0 20px;
    .template-name {
      color: #66b1ff;
      cursor: pointer;
    }
    .status {
      display: inline-block;
      width: 70px;
      margin-right: 5px;
      &.ing {
        color: #ffaa00;
      }
      &.suc {
        color: #7abd54;
      }
      &.fail {
        color: #ff4c4c;
      }
    }
  }
  .tips {
    border: 1px solid #ff9191;
    background-color: #ffe6e6;
    display: block;
    position: relative;
    color: #666;
    font-size: 12px;
    line-height: 30px;
    padding: 8px;
    border-radius: 3px;
    .em {
      color: #3388ff;
    }
  }
}
.popover {
  .title {
    line-height: 30px;
  }
  .content {
    color: #66b1ff;
  }
}
</style>

<style lang="less">
.upload-xls-btn {
  display: inline-block;
  margin: 0 10px;
}
</style>
